import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ParticipantsService} from "../service/participants.service";
import {animateShow} from "../../../../animations/showHideAnimation";
declare const Yiit;

@Component({
  selector: 'app-sidebar-participant',
  templateUrl: './sidebar-participant.component.html',
  styleUrls: ['./sidebar-participant.component.scss'],
  animations: [animateShow]
})
export class SidebarParticipantComponent implements OnInit {

  public participants: string[];
  public isOpened = false;
  public Yiit = Yiit;

  constructor(private participantService: ParticipantsService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.participantService.participantList.subscribe((list: string[])=>{
      this.participants = list;
    });
  }

  changeParticipant(val) {
    this.participantService.setCurrentParticipant(val);
  }
  toggleOpen(){
    this.isOpened = !this.isOpened;
    this.cd.detectChanges();
  }

}
